import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Currentmonth.api';

export const getCurrentMonthRequest = () => ({
  type: actionTypes.CURRENTMONTH_GET_REQUEST,
});

export const getCurrentMonthSuccess = (current_months) => ({
  type: actionTypes.CURRENTMONTH_GET_SUCCESS,
  payload: current_months,
});

export const getCurrentMonthFailure = (error) => ({
  type: actionTypes.CURRENTMONTH_GET_FAILURE,
  payload: error,
});

export const getCurrentMonth = (client_id) => {
  return async (dispatch) => {
    dispatch(getCurrentMonthRequest());
    try {
      const current_months = await api.fetchCurrentMonth();
      dispatch(getCurrentMonthSuccess(current_months));
      return { success: true, data: current_months };
    } catch (error) {
      dispatch(getCurrentMonthFailure(error));
      return { success: false, message: error };
    }
  };
};


export const CurrentMonthRequest = (CurrentMonth) => ({
  type: actionTypes.CURRENTMONTH_ADD_REQUEST,
  payload: CurrentMonth,
});

export const CurrentMonthSuccess = (CurrentMonth) => ({
  type: actionTypes.CURRENTMONTH_ADD_SUCCESS,
  payload: CurrentMonth,
});

export const CurrentMonthFailure = (error) => ({
  type: actionTypes.CURRENTMONTH_ADD_FAILURE,
  payload: error,
});

export const CurrentMonthInput = (CurrentMonth) => {
  return async (dispatch) => {
    dispatch(CurrentMonthRequest(CurrentMonth));
    try {
      const response = await api.CurrentMonthInput(CurrentMonth);
      if (response.status === 200) {
        dispatch(CurrentMonthSuccess(response.data.user));
        return { success: true };
      } else {
        dispatch(CurrentMonthFailure(response.message || 'CurrentMonth input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      const message = typeof error === 'string'
        ? error
        : (error?.message || 'An error occurred');
      dispatch(CurrentMonthFailure(message));
      throw message;
    }
  };
};



export const CreateCurrentMonthRequest = (CurrentMonth) => ({
  type: actionTypes.CREATE_CURRENTMONTH_ADD_REQUEST,
  payload: CurrentMonth,
});

export const CreateCurrentMonthSuccess = (CurrentMonth) => ({
  type: actionTypes.CREATE_CURRENTMONTH_ADD_SUCCESS,
  payload: CurrentMonth,
});

export const CreateCurrentMonthFailure = (error) => ({
  type: actionTypes.CREATE_CURRENTMONTH_ADD_FAILURE,
  payload: error,
});




export const CreateCurrentMonth = (CurrentMonth) => {
  return async (dispatch) => {
    dispatch(CurrentMonthRequest(CurrentMonth));
    try {
      const response = await api.CreateCurrentMonthInput(CurrentMonth);
      if (response.status === 200) {
        dispatch(CurrentMonthSuccess(response.data.user));
        return { success: true };
      } else {
        dispatch(CurrentMonthFailure(response.message || 'CurrentMonth input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {
      const message = typeof error === 'string'
        ? error
        : (error?.message || 'An error occurred');
      dispatch(CurrentMonthFailure(message));
      throw message;
    }
  };
};

